import { type ReactNode, useEffect } from "react";
import { useParams } from "react-router-dom";
import { errorReporter } from "./errorReporter";

/**
 * Tags Sentry events with the route's `appointmentID` while mounted. Wraps
 * every `appointments/:appointmentId*` route in routes.tsx, outside the lazy
 * page, so chunk-load errors are tagged too. Each browser tab has its own
 * Sentry scope, so concurrent tabs can't cross-tag.
 */
export const AppointmentErrorScope = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { appointmentId } = useParams<{ appointmentId: string }>();

  useEffect(() => {
    if (!appointmentId) {
      return;
    }
    errorReporter.setAppointmentContext(appointmentId);
    return () => errorReporter.clearAppointmentContext(appointmentId);
  }, [appointmentId]);

  return children;
};
